import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import PolicyPage from '../Policies/PolicyPage';
import termosDeUso from '../Policies/content/termosDeUso';

/**
 * Termos Gerais de Uso.
 *
 * A tela trazia uma redacao encurtada do documento, com clausulas inteiras de
 * fora -- 1.11 (comunicacao intermediada), 1.12 (Acompanhamento de Anfitrioes),
 * 5.5.1 (Nota do Anfitriao), o item Q da Visao Geral (direito de
 * arrependimento) e o corpo de 6.10. Como essas clausulas criam obrigacoes para
 * a Empiria e sao citadas pelas outras politicas, agora o texto e a transcricao
 * integral do PDF aprovado.
 */
const Terms = () => {
    const [searchParams] = useSearchParams();

    // A privacidade virou pagina propria em /privacidade. Este redirect existe
    // so para os links antigos que apontavam para a aba.
    if (searchParams.get('tab') === 'privacidade') return <Navigate to="/privacidade" replace />;

    return (
        <PolicyPage
            titulo="Termos Gerais de Uso da Empiria"
            versao="Versão publicada no dia 10 de outubro de 2025"
            blocos={termosDeUso}
        />
    );
};

export default Terms;
